/** Booking details helpers — category mapping + self prefill. */

export function apiPatientCategory(scope) {
  if (scope === 'self' || scope === 'faculty_staff') return 'faculty_staff';
  if (scope === 'dependent') return 'dependent';
  return 'non_dependent';
}

export function familyDependents(familyMembers) {
  return (familyMembers || []).filter((f) => (f.relationship || 'self') !== 'self');
}

export function selfFormFromPrefill(prefillPatient) {
  const p = prefillPatient || {};
  return {
    name: p.name || '',
    email: p.email || '',
    phone: p.phone || '',
    age: p.age != null ? String(p.age) : '',
    gender: p.gender || '',
    relationship: 'self',
    campus_member_id: p.id || '',
  };
}

export function isPortalFacultyCategories(allowedCategories) {
  return Array.isArray(allowedCategories)
    && allowedCategories.includes('self')
    && !allowedCategories.includes('faculty_staff');
}

export function isSelfOnlyCategories(allowedCategories) {
  return Array.isArray(allowedCategories)
    && allowedCategories.length === 1
    && allowedCategories[0] === 'self';
}
